import {h, Fragment} from "preact"
import {CheckboxTile} from "./elements"
import { updateOrderedArray } from "../helpers"



export default function FacetTileItem({facet, toggleProductFilter}) {

    if (facet.field == "skus.customFields.size") {
        let sortIt = ["5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "14", "15", "16", "17", "18", "26oz", "OS", "XS", "S", "S/M", "M", "L", "L/XL", "XL", "XXL", "XXXL"];
        updateOrderedArray(facet.data, sortIt);
    }
    return (
        <div class="ns-facet-tile-item" role="menu">
            {facet.data?.map(value => (
                <CheckboxTile
                    value={value.value}
                    selected={value.selected}
                    onChange={e => {
                        e.preventDefault()
                        toggleProductFilter(facet.field, value.value, !value.selected)
                    }}
                />
            ))}
        </div>
    )
}